import {
  getAttendanceById,
  getAttendanceVersions,
  Version,
} from "@/api/openapi";
import { AttendancesContext, PspContext } from "@/config/contexts";
import { translate } from "@/config/translator";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { attendanceToTempAttendance } from "../../attendanceUtils";

export function useAttendanceVersionsMobile() {
  const { lang, selectedMandate } = useContext(PspContext);
  const {
    selectedMonth,
    selectedYear,
    setAttendanceMonth,
    attendanceVersions,
    setAttendanceVersions,
    setTempAttendanceMonth,
    setIsSubmitted,
    setSubmittedAt,
  } = useContext(AttendancesContext);
  const navigate = useNavigate();

  const [restoreVersionConfirmationOpen, setRestoreVersionConfirmationOpen] =
    useState(false);
  const [confirmationOpenVersion, setConfirmationOpenVersion] =
    useState<Version | null>(null);

  useEffect(() => {
    if (!selectedMandate) {
      toast(translate("noMandateSelected", lang));
      return;
    }
    if (selectedMonth === undefined || selectedYear === undefined) {
      return;
    }
    getAttendanceVersions({
      query: {
        mandate_id: selectedMandate.id,
        month: selectedMonth,
        year: selectedYear,
      },
    }).then(({ data, error }) => {
      if (error) {
        toast(translate("somethingWentWrong", lang));
      } else {
        setAttendanceVersions(data);
      }
    });
  }, [
    lang,
    selectedMandate,
    selectedMandate?.id,
    selectedMonth,
    selectedYear,
    setAttendanceVersions,
  ]);

  function openRestoreVersionConfirmation(version: Version) {
    setConfirmationOpenVersion(version);
    setRestoreVersionConfirmationOpen(true);
  }

  function closeRestoreVersionConfirmation() {
    setRestoreVersionConfirmationOpen(false);
    setTimeout(() => setConfirmationOpenVersion(null), 250);
  }

  function onRestoreVersion() {
    if (!selectedMandate) {
      toast(translate("noMandateSelected", lang));
      return;
    }
    if (!confirmationOpenVersion) {
      toast(translate("somethingWentWrong", lang));
      return;
    }
    if (selectedMonth === undefined || selectedYear === undefined) {
      return;
    }
    getAttendanceById({
      query: {
        mandate_id: selectedMandate.id,
        month: selectedMonth,
        year: selectedYear,
      },
      path: {
        attendance_id: confirmationOpenVersion.id,
      },
    }).then(({ data, error }) => {
      if (error) {
        toast(translate("somethingWentWrong", lang));
        return;
      }
      setAttendanceMonth(data.data);
      setTempAttendanceMonth(attendanceToTempAttendance(data.data));
      setIsSubmitted(data.isSubmitted);
      setSubmittedAt(data.submittedAt ? new Date(data.submittedAt) : null);
      closeRestoreVersionConfirmation();
      navigate("/attendances");
    });
  }

  return {
    navigate,
    lang,
    attendanceVersions,
    onRestoreVersion,
    restoreVersionConfirmationOpen,
    openRestoreVersionConfirmation,
    closeRestoreVersionConfirmation,
    confirmationOpenVersion,
  };
}
